import { createNativeStackNavigator } from '@react-navigation/native-stack'
import { FC } from 'react'
import { ScreenEnum } from '../constants/screen'
import { RootStackParamList } from '../types/navigation'
import Customer from './Customer/Customer'
import MyApp from './MyApp'

const Stack = createNativeStackNavigator<RootStackParamList>()

const Navigation: FC = () => {
    return (
        <Stack.Navigator screenOptions={{ animation: 'none', headerShown: false }}>
            <Stack.Screen name={ScreenEnum.Digibon} component={MyApp} />
            <Stack.Screen name={ScreenEnum.Customer} component={Customer} />
        </Stack.Navigator>
    )
}

export default Navigation
